export default function configureLogging(initialvalue = true) {
    if(typeof initialvalue !== "boolean"){
            return;
    }
    window.activateWEBUILogs = initialvalue;
}

// WEBUILogs.log substitutes "console.log" and checks if the logging is permitted in the window object trough "window.activateWEBUILogs". If the value is set to "true", console.log is performed, otherwise nothing happens. The same logic applies for WEBUILogs.warn, which performs respectively "console.warn" and "WEBUILogs.error", which performs "console.error"

const shouldLog = () => {
    return window.activateWEBUILogs || window.activateWEBUILogs === undefined
}

export const WEBUILogs = {      
    log:  function(){        
        if(shouldLog()){
            console.log(...arguments);
        }
    },
    warn:  function(){
        if(shouldLog()){
            console.warn(...arguments);
        }
    },
    error:  function(){
        if(shouldLog()){
            console.error(...arguments);
        }
    }
}